import React  from 'react';

import RAGComponentProto from './rag-proto';

export default function renderRAGInFormNew(id, props) {
    return <RAGComponentProto renderMode="form-new" id={id} {...props} />;
}